export class LeadFullRequestModel {
    amount: number;
    currencyCode: string;
    leadId: string;
    discountMeasure: string;
    discountAmount: number;
    productId: string;
    purposeId: string;
    bidRate: number;
    countryCode: string;
    college: string;
    country: string;
    constructor(amount?: number,
        currencyCode?: string, leadId?: string, discountMeasure?: string,
        discountAmount?: number, productId?: string, purposeId?: string, bidRate?: number, countryCode?: string,
        college?: string, country?: string) {
        this.amount = amount;
        this.currencyCode = currencyCode;
        this.leadId = leadId;
        this.discountMeasure = discountMeasure;
        this.discountAmount = discountAmount;
        this.productId = productId;
        this.purposeId = purposeId;
        this.bidRate = bidRate;
        this.countryCode = countryCode;
        this.college = college;
        this.country = country;
    }
}
export class ParamIdRequestModel {
    consumerId: string;
    partnerId: string;
    userId: string;
    constructor(consumerId?: string, partnerId?: string, userId?: string) {
        this.consumerId = consumerId;
        this.partnerId = partnerId;
        this.userId = userId;
    }
}



// WEBPACK FOOTER //
// ./src/app/_models/leadFull/LeadFullRequestModel.ts